module.exports = __webpack_public_path__ + "assets/35f6f54c9999fa1aa4754878b4fa1778.png";